import { combineReducers } from "redux";
import {
  themeReducer,
  darkReducer,
  getDataReducer,
  getFilteredDataReducer,
  getTrending,
  getTopStories,
  getPopular,
  getTopHeadlines,
} from "./reducers";

const reducers = combineReducers({
  allThemes: themeReducer,
  darkmode: darkReducer,
  allporfolio: getDataReducer,
  filteredporfolio: getFilteredDataReducer,
  getPopular: getPopular,
  getTopStories: getTopStories,
  getTrending: getTrending,
  getTopHeadlines: getTopHeadlines,
});

export default reducers;
